export const getPriceString = (price?: number, discount?: number): string | null => {
  return price ? `${Math.ceil(price - price * ((discount ?? 0) / 100)).toLocaleString()} HUF` : null;
};

export const getDurationString = ({ minDuration, maxDuration }: { minDuration?: number; maxDuration: number }): string =>
  `${minDuration ? `${minDuration} - ` : ''} ${maxDuration} Hrs`;
